import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { fadeInLeft } from "react-animations";
import { bodyColor } from "../../config/constants";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInLeft}`;

// Styles
export const PatientDiv = styled.div`
  margin: 0 auto 10px;
  height: 50px;
  max-width: 860px;
  display: flex;
  border-radius: 35px 5px 5px 35px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    width: 85%;
    height: auto;
    flex-direction: column;
    align-items: flex-end;
    box-shadow: none;
    transition: all 0.5s ease-out;
  }
`;
export const UserDiv = styled.div`
  width: 210px;
  display: flex;
  align-items: center;
  border-radius: 35px 0 0 35px;
  background-color: #fff;
  @media (max-width: 910px) {
    padding-right: 30px;
    width: 100%;
    border-radius: 35px 5px 5px 35px;
    position: relative;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
  @media (max-width: 470px) {
    padding: 5px 32px 5px 0;
  }
`;
export const AvatarDiv = styled.div`
  width: 50px;
  height: 50px;
  @media (max-width: 470px) {
    margin-left: 5px;
  }
`;
export const AvatarImg = styled.img`
  width: 50px;
  height: 50px;
`;
export const UserInfoDiv = styled.div`
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
`;
export const UserText = styled.p`
  font-size: 14px;
  font-weight: 600;
`;
export const UserInfoText = styled.p`
  display: none;
  font-size: 14px;
  @media (max-width: 910px) {
    display: flex;
  }
`;
export const ShowAppsButton = styled.button`
  padding: 0 5px;
  height: 80%;
  display: none;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid ${bodyColor};
  position: absolute;
  right: 0;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    align-items: center;
  }
`;
export const ShowAppsImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const ProfileDiv = styled.div`
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ProfileLink = styled(Link)`
  width: 100%;
  height: 80%;
  border-left: 2px solid ${bodyColor};
  border-right: 2px solid ${bodyColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ProfileImg = styled.img`
  width: 25px;
  height: 25px;
`;
export const InformationDiv = styled.div`
  width: 300px;
  padding: 0 5px 0 40px;
  display: flex;
  align-items: center;
  background-color: #fff;
  font-size: 14px;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ApplicationDiv = styled.div`
  width: 300px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #fff;
  border-radius: 0 5px 5px 0;
  @media (max-width: 910px) {
    margin-top: 2px;
    width: auto;
    max-width: 90%;
    height: 40px;
    display: ${({ show }) => (show ? "flex" : "none")};
    justify-content: normal;
    border-radius: 5px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    animation: 0.5s ${fadeInDownAnimation};
    overflow: scroll hidden;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;
export const ApplicationProfileLink = styled(Link)`
  width: 50px;
  height: 40px;
  display: none;
  align-items: center;
  justify-content: center;
  @media (max-width: 910px) {
    display: flex;
  }
`;
export const ApplicationProfileImg = styled.img`
  margin: 0 9px;
  width: 25px;
  height: 25px;
`;
export const ApplicationLink = styled(Link)`
  width: 50px;
  height: 80%;
  border-left: 2px solid ${bodyColor};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
export const SoftwareFilterIndicator = styled.div`
  width: 100%;
  height: 2px;
  display: ${({ display }) => display && display};
  background-color: #999;
  position: absolute;
  top: -9px;
  animation: 0.3s ${fadeInDownAnimation};
  @media (max-width: 910px) {
    display: none;
  }
`;
export const ApplicationImg = styled.img`
  margin: 0 9px;
  width: 25px;
  height: 25px;
`;
